var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.permissions),function(item){return _c('vs-chip',{key:item,attrs:{"color":_vm.color(item)}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }